import React,{Component} from 'react';
import _ from 'lodash';
export default class Plan extends Component{

    constructor(props){
        super(props);
        this.state={
            beforeChangePlanText: '',
            afterChangePlanText: ''
        };
        this.handleClick=this.handleClick.bind(this);
    }
    // handle click when we click on a plan (subscription page)
    handleClick(event){
        var selectedPlanPrirority = this.props.plan.priority;
        var existigPlan = _.filter(this.props.selectedPlan.plans.subscription,{'_id': this.props.selectedPlan.selected_subscription});
        var upgradeDownMsg=''
        if(selectedPlanPrirority>existigPlan[0].priority){
            upgradeDownMsg='Your subscription will now be updated and your stored credit card charged.';
            this.setState({beforeChangePlanText: upgradeDownMsg });
        }else{
            upgradeDownMsg='Your subscription will now be updated and your stored credit card charged.';
            this.setState({beforeChangePlanText: upgradeDownMsg});
        }
        this.props.planClick(this.props.plan._id,upgradeDownMsg);
    }

    render(){
       
        if(this.props.plan){
        const subscriptionClass=(this.props.isSelected)?'subscription-box selected':'subscription-box';
        
        const base_price=this.props.plan.price

        let plan_price=base_price,tax_applied=0
        
        this.props.taxes.forEach(tax => {
            tax_applied+=((base_price*tax.percentage)/100)
        });

        plan_price=plan_price+tax_applied;
        //only show original price , not include tax
        plan_price=base_price;
        let plan_price_pm=parseInt((this.props.plan.duration_type==='MONTHLY')?plan_price:(plan_price/12));
        plan_price_pm=plan_price_pm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return (
                <div className={subscriptionClass}> 
                        {this.props.plan.duration_type==='YEARLY'&& 
                        <div className="save-strip">
                            <p>Save <span>15%</span></p>
                        </div>
                        }
                        <div className="subscription-heading">
                            <h5>{this.props.plan.label}</h5>
                            <p>{(this.props.plan.allowance===null)?'Unlimited':this.props.plan.allowance} Projects</p>
                        </div>
                        <h4>
                            <span className="euro-icon">&pound;</span>
                            {plan_price_pm}
                            <span className="per-month">/month</span>
                        </h4>
                        <div className="select-button">
                            <button type="button" onClick={this.handleClick}>{this.props.isCurrentPlan?'Current Plan':'Select'}</button>
                        </div> 
                </div>
            );
        }

        return '';
    }

}


// WEBPACK FOOTER //
// ./src/Components/Modules/Subscription/Plan.js